import AltContainer from 'alt-container';
import React from 'react';
import AdminWelcomeEmail from 'components/pure/admin/AdminWelcomeEmail';
import AdminWelcomeEmailStore from 'stores/admin/AdminWelcomeEmailStore';
import AdminWelcomeEmailActions from 'actions/admin/AdminWelcomeEmailActions';

export default class AdminWelcomeEmailContainer extends React.Component {
  componentDidMount() {
    AdminWelcomeEmailActions.fetchUserList();
  }

  render() {
    return (
      <AltContainer stores={{AdminWelcomeEmailStore}}>
        <AdminWelcomeEmail />
      </AltContainer>
    );
  }
}
